import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { Box, Divider, Text } from '@chakra-ui/react';
import { useMemo } from 'react';
import { SearchIcon } from '../../assets/icons';
import Icon from '../../components/Icon';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
export default function SearchSummary(_ref) {
  var handleEdit = _ref.handleEdit,
    isSummaryActive = _ref.isSummaryActive,
    location = _ref.location,
    dateInterval = _ref.dateInterval,
    roomSummary = _ref.roomSummary,
    numberOfNightsSummary = _ref.numberOfNightsSummary,
    promotionCategorySummary = _ref.promotionCategorySummary,
    contractRateSummary = _ref.contractRateSummary,
    editText = _ref.editText,
    isLessThanMd = _ref.isLessThanMd,
    isLessThanSm = _ref.isLessThanSm,
    isLessThanLg = _ref.isLessThanLg,
    style = _ref.style;
  var showCanEdit = useMemo(() => isLessThanMd || isLessThanSm, [isLessThanMd, isLessThanSm]);
  var hoverObject = showCanEdit ? {
    _hover: {}
  } : {};
  return isSummaryActive ? _jsxs(_Fragment, {
    children: [_jsxs(Box, _objectSpread(_objectSpread(_objectSpread(_objectSpread({
      role: !showCanEdit ? 'group' : '',
      "data-testid": "search-summary-container"
    }, styledSearchSummaryContainer), hoverObject), style === null || style === void 0 ? void 0 : style.containerStyle), {}, {
      onClick: e => {
        e.preventDefault();
        if (!showCanEdit) {
          handleEdit();
        }
      },
      children: [_jsx(Box, _objectSpread(_objectSpread({}, styledSearchIcon), {}, {
        children: _jsx(Icon, {
          svg: _jsx(SearchIcon, {
            "data-testid": "search-icon"
          })
        })
      })), location && _jsxs(Box, _objectSpread(_objectSpread(_objectSpread({}, styledSummaryInfoBox), styledLocation), {}, {
        children: [_jsx(Text, _objectSpread(_objectSpread({}, styledText), {}, {
          "data-testid": "search-summary-location",
          children: location
        })), (isLessThanSm || isLessThanLg && !roomSummary) && _jsx(Text, _objectSpread(_objectSpread({}, styledEditText), {}, {
          "data-testid": "search-summary-edit-link",
          onClick: e => {
            e.preventDefault();
            handleEdit();
          },
          children: editText
        }))]
      })), !isLessThanSm ? handleSummaryInfoBoxMobile({
        dateInterval,
        roomSummary,
        numberOfNightsSummary,
        promotionCategorySummary,
        contractRateSummary,
        isLessThanLg,
        handleEdit,
        editText
      }) : dateInterval && roomSummary && _jsx(Box, _objectSpread(_objectSpread({}, _objectSpread(_objectSpread({}, styledSummaryInfoBox), styledSummaryInfoBoxMobile)), {}, {
        "data-testid": "search-summary-date-rooms",
        children: "".concat(dateInterval, ", ").concat(roomSummary)
      }))]
    })), _jsx(Divider, {
      marginTop: "-1px"
    })]
  }) : null;
}
function handleSummaryInfoBoxMobile(_ref2) {
  var dateInterval = _ref2.dateInterval,
    roomSummary = _ref2.roomSummary,
    numberOfNightsSummary = _ref2.numberOfNightsSummary,
    promotionCategorySummary = _ref2.promotionCategorySummary,
    contractRateSummary = _ref2.contractRateSummary,
    isLessThanLg = _ref2.isLessThanLg,
    handleEdit = _ref2.handleEdit,
    editText = _ref2.editText;
  return _jsxs(_Fragment, {
    children: [dateInterval && _jsx(Box, _objectSpread(_objectSpread(_objectSpread({
      "data-testid": "search-summary-dates"
    }, styledSummaryInfoBox), styledSummaryInfoBoxMobile), {}, {
      children: _jsx(Text, _objectSpread(_objectSpread({}, styledText), {}, {
        children: dateInterval
      }))
    })), numberOfNightsSummary && _jsx(Box, _objectSpread(_objectSpread(_objectSpread({
      "data-testid": "search-summary-number-of-nights"
    }, styledSummaryInfoBox), styledSummaryInfoBoxMobile), {}, {
      children: _jsx(Text, _objectSpread(_objectSpread({}, styledText), {}, {
        children: numberOfNightsSummary
      }))
    })), roomSummary && _jsxs(Box, _objectSpread(_objectSpread(_objectSpread({
      "data-testid": "search-summary-rooms"
    }, styledSummaryInfoBox), styledSummaryInfoBoxMobile), {}, {
      children: [_jsx(Text, _objectSpread(_objectSpread({}, styledText), {}, {
        children: roomSummary
      })), isLessThanLg && _jsx(Text, _objectSpread(_objectSpread({}, styledEditText), {}, {
        onClick: e => {
          e.preventDefault();
          handleEdit();
        },
        children: editText
      }))]
    })), promotionCategorySummary && _jsx(Box, _objectSpread(_objectSpread(_objectSpread({
      "data-testid": "search-summary-promotion-category"
    }, styledSummaryInfoBox), styledSummaryInfoBoxMobile), {}, {
      children: _jsx(Text, _objectSpread(_objectSpread(_objectSpread({}, styledText), styledTextInactive), {}, {
        children: promotionCategorySummary
      }))
    })), contractRateSummary && _jsx(Box, _objectSpread(_objectSpread(_objectSpread({
      "data-testid": "search-summary-contract-rate"
    }, styledSummaryInfoBox), styledSummaryInfoBoxMobile), {}, {
      children: _jsx(Text, _objectSpread(_objectSpread({}, styledText), {}, {
        children: contractRateSummary
      }))
    }))]
  });
}
var styledSearchSummaryContainer = {
  width: '100%',
  display: 'flex',
  flexDirection: {
    mobile: 'initial',
    sm: 'row'
  },
  flexWrap: {
    mobile: 'wrap',
    sm: 'initial'
  },
  padding: {
    lg: '1.5rem 0',
    md: 'var(--chakra-space-md) 0',
    mobile: '1rem 0'
  },
  alignItems: 'center',
  border: '1px solid transparent',
  cursor: 'pointer',
  height: {
    sm: 'var(--chakra-space-4xl)',
    md: 'var(--chakra-space-6xl)'
  },
  _hover: {
    boxShadow: '0px 0px 8px var(--chakra-colors-lightGrey4)',
    padding: '0',
    border: '1px solid var(--chakra-colors-lightGrey4)'
  }
};
var styledSearchIcon = {
  display: 'flex',
  paddingLeft: {
    sm: 'var(--chakra-space-md)',
    mobile: '0'
  },
  _groupHover: {
    padding: {
      lg: 'var(--chakra-space-lg) 0 var(--chakra-space-lg) var(--chakra-space-md)',
      md: 'var(--chakra-space-md) 0 var(--chakra-space-md) var(--chakra-space-md)'
    }
  }
};
var styledLocation = {
  fontWeight: {
    mobile: 'semibold',
    sm: 'normal'
  },
  flex: {
    sm: 'initial',
    mobile: '1 1 calc(100% - 37px)'
  },
  _after: {
    content: '""'
  }
};
var styledSummaryInfoBox = {
  display: 'flex',
  overflow: 'hidden',
  borderWidth: {
    sm: '0 1px 0 0',
    mobile: '0 0 0 0'
  },
  borderColor: 'lightGrey4',
  padding: {
    lg: '0 var(--chakra-space-lg)',
    sm: '0 var(--chakra-space-md)',
    mobile: '0 var(--chakra-space-xmd)'
  },
  _last: {
    borderRight: 'none',
    flex: {
      md: '1',
      mobile: 'initial'
    }
  },
  _groupHover: {
    padding: {
      lg: 'var(--chakra-space-lg)',
      sm: 'var(--chakra-space-md)'
    },
    borderWidth: '0 1px 0 0',
    borderColor: 'lightGrey4',
    _last: {
      borderRight: '0'
    }
  }
};
var styledSummaryInfoBoxMobile = {
  _notLast: {
    _after: {
      content: {
        sm: '""',
        mobile: '","'
      }
    }
  },
  padding: {
    mobile: '0.25rem 0.125rem',
    lg: '0 var(--chakra-space-lg)',
    sm: '0 var(--chakra-space-md)'
  }
};
var styledEditText = {
  display: 'inline-flex',
  marginLeft: 'var(--chakra-space-md)',
  textDecoration: 'underline',
  color: 'darkGrey3',
  fontWeight: 'normal',
  fontSize: 'sm'
};
var styledText = {
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  padding: '0'
};
var styledTextInactive = {
  color: 'lightGrey4'
};